import { loadDemoReview } from ".";
import store, { type AppDispatch, type AppState, UsePortalSelector } from '../..';
import { selectQuoteFromId } from "../quotes/hooks";

const selectQuoteDemoReview = (quoteId: number) => (state: AppState) => {
	const demoReview = state.entity.quoteDemoReviews[quoteId];
	const dispatch = store.dispatch as AppDispatch;

	const quote = selectQuoteFromId(quoteId)(state);
	const isDemo = quote?.quote_type_id === 6;

	if (demoReview?.name === "None" || !isDemo) return null;

	if (!demoReview) {
		dispatch(loadDemoReview(quoteId));
		return null;
	}

	return demoReview;
};

const useQuoteDemoReview = (quoteId: number) => UsePortalSelector(selectQuoteDemoReview(quoteId));

export {
	useQuoteDemoReview,
	selectQuoteDemoReview,
	loadDemoReview
};
